import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Github } from 'lucide-react';
import GTLogo from './GTLogo';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top container">
        <div className="footer-brand">
          <Link to="/" className="logo footer-logo">
            <GTLogo size={40} />
            <div className="logo-text">
              <span className="logo-main">Tradify</span>
              <span className="logo-sub">Me</span>
            </div>
          </Link>
          <p className="footer-tagline">
            Engineering the future through precision software, strategic consulting, and transformative technology solutions.
          </p>
          <div className="footer-socials">
            <a href="#!" aria-label="LinkedIn"><Linkedin size={18} /></a>
            <a href="#!" aria-label="Twitter"><Twitter size={18} /></a>
            <a href="#!" aria-label="GitHub"><Github size={18} /></a>
          </div>
        </div>

        <div className="footer-links-group">
          <h4>Company</h4>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/testimonials">Testimonials</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-links-group">
          <h4>Services</h4>
          <ul>
            <li><a href="/services">Software Development</a></li>
            <li><a href="/services">IT Consulting</a></li>
            <li><a href="/services">Cloud Solutions</a></li>
            <li><a href="/services">Cybersecurity</a></li>
            <li><a href="/services">Data Analytics</a></li>
          </ul>
        </div>

        <div className="footer-links-group">
          <h4>Contact</h4>
          <ul className="footer-contact-list">
            <li>
              <MapPin size={14} />
              <span>Pune, Maharashtra, India</span>
            </li>
            <li>
              <Phone size={14} />
              <span>+91 90999 09090</span>
            </li>
            <li>
              <Mail size={14} />
              <span>info@Tradifyme.in</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom container">
        <p>© {new Date().getFullYear()} Tradifyme. All rights reserved.</p>
        <div className="footer-legal">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <span>·</span>
          <Link to="/terms-conditions">Terms & Conditions</Link>
        </div>
      </div>
    </footer>
  );
}
